<template>
  <header>
    <div class="menu" v-if="config.qaTime">
      <span :class="{active: index == n}" v-for="(item, index) in menus" @click="toggle(index)" :key="'menu-' + index">
        <i class="icon iconfont icon-luzhi" v-if="index == n"></i>
        <i class="icon iconfont icon-bofang" v-if="index != n"></i>
        {{item.name}}
        <i class="icon iconfont icon-guanbi" v-if="index != 0" @click="closeQATag"></i>
      </span>
    </div>
    <div class="base">
      <span class="blod" v-if="!config.qaTime">教师端</span>
      <span class="">教室ID：{{config.roomId}}</span>
      <span class="">在线人数：{{config.number}}</span>
      <!-- <span class="live-btn" @click="startLive">开始</span> -->
      <!--<span v-if="!config.isLive" class="live-btn" v-tooltip.top-center="tip.start" @click="startLive">开始</span>
      <span v-else class="live-btn" v-tooltip.top-center="tip.end" @click="endLive">结束</span>-->
    </div>
    <div class="file" v-if="config.role">
      <span class="fi-wrap" :class="index===1&&hasNewQuestion?'active':''" v-for="(i, index) in icons" v-tooltip="{content: i.info, classes: 'tips-tooltip', placement: 'bottom' }" @click="fileOperation(index)" :key="'control-' + index">
        <i :class="['icon', 'iconfont', i.icon ]"></i>
      </span>
    </div>
  </header>
</template>

<script>
import EventBus from '@/views/eventBus'
export default {
  props: {
    config: {
      type: Object,
      default: function () {
        return {
          role: 0,
          isLive: false,
          nameQA: ''
        }
      }
    }
  },
  data () {
    return {
      qaTime: true,
      icons: [
        {icon: 'icon-editor1', info: '发布问卷', ishow: false},
        {icon: 'icon-qa', info: '学生提问', ishow: false},
        {icon: 'icon-qingchu1', info: '清除代码', ishow: false},
        {icon: 'icon-daochu1', info: '导出代码', ishow: false}
      ],
      n: 1,
      hover: -1,
      tip: {
        start: '开始上课',
        end: '结束上课'
      },
      hasNewQuestion: false
    }
  },
  created () {
  },
  watch: {
    'config.forceChangeQAIndex'(val) {
      this.n = 1
    }
  },
  computed: {
    menus: function() {
      let menuData = [
        {name: '我的代码'},
        {name: this.config.nameQA + '的代码' || '学生的代码'}
      ]
      return menuData
    }
  },
  mounted () {
    console.log(this.config)
    this.socket.on('student.qa', (data) => {
      this.hasNewQuestion = true
    })
  },
  methods: {
    toggle(index) {
      console.log('1234567890-')
      if (this.n !== index) {
        this.n = index
        this.$emit('checkCode', index)
      }
    },
    initOptions () {},
    fileOperation(index) {
      console.log(index, typeof index)
      if (index === 0) this.issueQuestion()
      if (index === 1) {
        this.studentQuestionAsk()
        this.hasNewQuestion = false
      }
      if (index === 2) this.clearCode()
      if (index === 3) this.exportCodeFile()
    },
    startLive() {
      this.$emit('startLesson', this.$route.params.languageId)
    },
    endLive() {
      this.$emit('endLesson', this.$route.params.languageId)
    },
    issueQuestion() {
      this.$emit('IQNaire', this.$route.params.languageId)
    },
    studentQuestionAsk() {
      this.$emit('studentQA', this.$route.params.languageId)
    },
    clearCode() {
      this.$emit('clearEditor', this.$route.params.languageId)
    },
    exportCodeFile() {
      this.$emit('exportFile', this.$route.params.languageId)
    },
    closeQATag() {
      console.log('closeQA')
      EventBus.$emit('closeQAMenu')
    }
  }
}
</script>

<style lang="scss" scoped>
header{
  border-bottom: 1px solid #1FB6FF;
  height: 48px;
  padding: 0 36px;
  background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
  background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
  // overflow-x: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  .active{
    background-color: #fff !important;
    color: #1FB6FF !important;
    .icon{

    }
  }
  .menu{
    float: left;
    margin-top: 16px;
    cursor: pointer;

    span{
      background-color: rgba(255, 255, 255, 0.3);
      color: #fff;
      height: 28px;
      vertical-align: bottom;
      line-height: normal;
      padding: 8px 8px 20px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 8px;
      margin-right: 8px;
    }
  }
  .base{
    float: left;
    color: #FFF;
    font-size: 16px;
    line-height: 56px;

    span{
      padding: 0 12px;
      border-right: 2px solid #FFF;
      font-weight: 300;
    }
    span:last-child{
      border-right: 2px solid transparent;
    }
  }
  .file{
    float: right;
    height: 48px;
    .icon{
      font-size: 24px;
      color: rgba(255,255,255,0.8);
      cursor: pointer;
      vertical-align: middle;
      -webkit-font-smoothing: antialiased;

      &:hover {
        color: rgba(255,255,255,1);
      }
    }
    .fi-wrap{
      position: relative;
      margin-right: 12px;
      display: inline-block;
      margin-top: 12px;
      height: 24px;
      &.active {
        background: none !important;
        color: inherit !important;
        &:before {
          content: '';
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #f00;
          right: 0;

        }
      }
    }
    .i-tip{
      position: absolute;
      visibility: hidden;
      left: -25px;
      top: -32px;
    }
    .i-tip:hover{
      visibility: visible;
    }
    span{
    }
  }
}
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6c489622